<template>
    <div class="form-group">
        <label class="font-bold mb-md block">Filter</label>

        <table class="w-full">
            <thead v-if="filtersData.length">
                <tr>
                    <th class="font-regular text-sm text-left">Fält</th>
                    <th class="font-regular text-sm text-left" />
                    <th class="font-regular text-sm text-left">Värde</th>
                    <th />
                </tr>
            </thead>
            <tbody>
                <template v-for="(filterData, index) in filtersData">
                    <filter-table-row
                        :key="index"
                        :filter-data="filterData"
                        :index="index"
                        :input-data="inputData"
                        @remove-row="removeFilter"
                    />
                </template>
                <template v-if="filtersData.some && filtersData.some(function(filterData) { return filterData.name === 'has_invoices'; })">
                    <tr>
                        <td colspan="4" style="font-weight: bold;">
                            * Filtret <span class="italic">Finns fakturor</span> gäller endast fr.o.m. {{ hasInvoicesStartDate }}.
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>

        <button
            type="button"
            class="btn-link mt-sm"
            @click="addFilter"
        >
            + Lägg till filter
        </button>

        <div v-if="this.$slots.default" class="my-md">
            <slot />
        </div>
    </div>
</template>

<script>
    import FilterTableRow from './FilterTableRow';

    export default {
        components: {
            FilterTableRow,
        },

        props: {
            inputData: {
                type: Object,
                required: true,
            },
            initialFiltersData: {
                type: Array,
                required: true,
            },
            hasInvoicesStartDate: {
                type: String,
                required: true,
            },
        },

        data() {
            return {
                filtersData: this.initialFiltersData,
            };
        },

        methods: {
            addFilter() {
                this.filtersData.push({
                    name: '',
                    operator: this.inputData.defaultOperator,
                    value: null,
                });
            },
            removeFilter(index) {
                this.filtersData.splice(index, 1);
            },
        },
    };
</script>
